import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, takeEvery, put } from "redux-saga/effects";
import Axios, { AxiosResponse } from "axios";
import { configs } from "../../../common";

export const SubmitClarification = createSlice({
  name: "SubmitClarification",
  initialState: {
    data: [],
    isSuccess: false,
    isLoading: false,
  },
  reducers: {
    submit_clarification: (state, action?) => {
      state.isLoading = true;
    },
    submit_clarification_success: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
    },
    submit_clarification_failure: (state, action) => {
      state.isLoading = false;
    },
  },
});
export default SubmitClarification.reducer;
export const {
  submit_clarification,
  submit_clarification_success,
  submit_clarification_failure,
} = SubmitClarification.actions;

//

const api = configs.api + "/api/accounts_onboarding/partner_clarification";
// const api =
//   "http://192.168.1.112:3035/api/accounts_onboarding/partner_clarification";

const getCall = async (a: any) => {
  let token = await localStorage.getItem("SpApperalsToken");
  return Axios.post(api, a.payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export function* SubmitClarificationApi(e: any) {
  try {
    const response: AxiosResponse = yield call(getCall, e);

    yield put(submit_clarification_success(response.data));
  } catch (e) {
    console.log(e);
    yield put(submit_clarification_failure(e));
  }
}
